module.exports = __webpack_public_path__ + "media/images/project/clipboard-edit-outline-new-70b2da2cb10b5b0806cdf4b5ecff35e2.svg";